import React, { createContext, useState } from "react";

const _default = {
  loggedUser: null,

  sidebarExpand: false,
  currentRoute: null,
  pdfForPreview: null,
  showPreload: false,

  manuals: [],
  alerts: [],
  promotions: [],
  topPromotions: [],
  topSkirts: [],
  topManuals: [],
  topCatalogs: [],
  skirts: [],
  lastFiles: [],
  banners: [],
  loadingSkirt: false,

  searchResult: [],
  searching: false,
  search: "",
  isAdmin: false
};

export const StoreContext = createContext(_default);

const StoreProvider = ({ children }) => {
  const [loggedUser, setLoggedUser] = useState(_default.loggedUser);
  const [isAdmin, setIsAdmin] = useState(_default.isAdmin);

  const [sidebarExpand, setSidebarExpand] = useState(_default.sidebarExpand);
  const [currentRoute, setCurrentRoute] = useState(_default.currentRoute);
  const [pdfForPreview, setPdfForPreview] = useState(_default.pdfForPreview);
  const [showPreload, setShowPreload] = useState(_default.showPreload);

  const [alerts, setAlerts] = useState(_default.alerts);
  const [promotions, setPromotions] = useState(_default.promotions);
  const [topPromotions, setTopPromotions] = useState(_default.topPromotions);
  const [topSkirts, setTopSkirts] = useState(_default.topSkirts);
  const [topManuals, setTopManuals] = useState(_default.topManuals);
  const [topCatalogs, setTopCatalogs] = useState(_default.topCatalogs);
  const [manuals, setManuals] = useState(_default.manuals);
  const [skirts, setSkirts] = useState(_default.skirts);
  const [lastFiles, setLastFiles] = useState(_default.lastFiles);
  const [banners, setBanners] = useState(_default.banners);
  const [loadingSkirt, setLoadingSkirt] = useState(_default.loadingSkirt);

  const [searchResult, setSearchResult] = useState(_default.searchResult);
  const [searching, setSearching] = useState(_default.searching);
  const [serach, setSearch] = useState(_default.search);

  const values = {
    loggedUser,
    setLoggedUser,
    isAdmin,
    setIsAdmin,

    sidebarExpand,
    setSidebarExpand,
    currentRoute,
    setCurrentRoute,
    pdfForPreview,
    setPdfForPreview,
    showPreload,
    setShowPreload,

    alerts,
    setAlerts,
    promotions,
    setPromotions,
    topPromotions,
    setTopPromotions,
    manuals,
    setManuals,
    skirts,
    setSkirts,
    topSkirts,
    setTopSkirts,
    topManuals,
    setTopManuals,
    topCatalogs,
    setTopCatalogs,
    lastFiles,
    setLastFiles,
    banners,
    setBanners,
    loadingSkirt,
    setLoadingSkirt,

    searchResult,
    setSearchResult,
    searching,
    setSearching,
    serach,
    setSearch,
  };

  return (
    <StoreContext.Provider value={values}>{children}</StoreContext.Provider>
  );
};

export default StoreProvider;
